module.exports = __webpack_public_path__ + "static/img/LISBON_PAINT.39e0a99.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/LISBON_PAINT.jpg
// module id = bpAS
// module chunks = 0